import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Accordion from "react-bootstrap/Accordion";
import AccordionCollapse from "react-bootstrap/AccordionCollapse";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";

import { IoMdAdd } from "react-icons/im";

import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { GrAttachment } from "react-icons/gr";

import Star from "../../asset/img/star1.png";
import StarFill from "../../asset/img/star_fill.png";
import Plus from "../../asset/img/plus1.png";
import Minus from "../../asset/img/minus1.png";
import TeamCard from "./TeamCard";
import {
  getGamedata,
  getOddsList,
  getGamedatas,
} from "../actions/gameSettings";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "../lib/isEmpty";

import SingelEvents from "./SingelEvents";
import DataFetchStatus from "../common/DataFetchStatus";

function CustomToggle({ children, eventKey, icon, handleIconm }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => { });

  return (
    <div type="button" onClick={decoratedOnClick}>
      <span onClick={handleIconm}>{children}</span>
    </div>
  );
}

function AllEvents({ SelectDisplay, handleselect }) {
  const [icon, setIcon] = useState(true);
  const dispatch = useDispatch();
  const { selectedSport } = useSelector((state) => state.sportData);
  useEffect(() => {
    fetchGameData();
  }, []);

  const [isOpenn, setIsOpenn] = useState();
  const [getGameData, setGameData] = useState([]);
  const [getGames, setGames] = useState([]);
  const [eventMessage, seteventMessage] = useState([]);
  const [gamesLoading, setGamesLoading] = useState(true);
  const [gamesError, setGamesError] = useState(null);

  const [isCheckAll, setIsCheckAll] = useState([]);
  const [checkInd, setcheckInd] = useState([]);

  const handleSelectAll = (e, item, index) => {
    if (e.target.checked) {
      const nextCheckAll = [...isCheckAll, index];
      setIsCheckAll(nextCheckAll);
      let ind = [...checkInd];
      item.forEach((val) => {
        const isExist = ind.find((val1) => val1 == val);
        if (isEmpty(isExist)) {
          ind.push(val);
        }
      });
      setcheckInd(ind);
      handleselect(true);
      fetchOddsDetails({ sport_key: ind });
    } else {
      const nextCheckAll = isCheckAll.filter((val) => val !== index);
      setIsCheckAll(nextCheckAll);
      const toRemove = new Set(item);
      const nextInd = checkInd.filter((k) => !toRemove.has(k));
      setcheckInd(nextInd);
      fetchOddsDetails({ sport_key: nextInd });
    }
  };

  function handleChange(e, item, index) {
    let CheckInd = [...checkInd];
    let IsCheckAll = [...isCheckAll];
    if (e.target.checked) {
      CheckInd.push(item.key);
      setcheckInd(CheckInd);
      handleselect(true);
      fetchOddsDetails({ sport_key: CheckInd });
    } else {
      let fidIndxx = IsCheckAll.findIndex((val) => val == index);
      IsCheckAll.splice(fidIndxx, 1);
      setIsCheckAll(IsCheckAll);
      let fidIndx = CheckInd.findIndex((val) => val == item.key);
      CheckInd.splice(fidIndx, 1);
      setcheckInd(CheckInd);
      handleselect(true);
      fetchOddsDetails({ sport_key: CheckInd });
    }
  }

  const toggleAccordionn = (id) => {
    if (isOpenn == id) {
      setIsOpenn();
    } else {
      setIsOpenn(id);
    }
  };

  const handleIconss = () => {
    setIcon(!icon);
  };

  const fetchGameData = async () => {
    setGamesLoading(true);
    setGamesError(null);
    try {
      let { status, message, result } = await getGamedatas(dispatch);
      console.log(
        "🚀 ~ fetchGameData ~ status, message, result:",
        status,
        message,
        result
      );
      if (status == true) {
        setGameData(result);
      } else {
        seteventMessage(message);
        setGamesError(message || "Unable to load sports list.");
      }
    } catch (err) {
      console.log("err", err);
      setGamesError("Unable to load sports. Please try again.");
    } finally {
      setGamesLoading(false);
    }
  };



  const fetchOddsDetails = async (data) => {
    console.log('fetchOddsDetails_array', data)
    try {
      let { status, message, result } = await getOddsList(data, dispatch);
      console.log(
        "🚀 ~ fetchOddsDetails ~ status, message, result:",
        status,
        message,
        result
      );
      if (status == true) {
        // setGameData(result);
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  console.log('getGameData', getGameData)
  return (
    <div className="parlay_tabs all_events mb-5 ">
      <DataFetchStatus loading={gamesLoading} error={gamesError}>
        <div className="games_sec">
          {getGameData && getGameData.length > 0
            ? getGameData?.map((item, index) => {
              {
                if (selectedSport == item._id) {
                  return (
                    <div key={item._id} className="row mx-auto">
                      <div className="col-xxl-5 col-xl-6 col-lg-5 col-md-7 col-sm-8 col-12">
                        <Accordion
                          // defaultActiveKey={0}
                          defaultActiveKey={SelectDisplay ? 1 : 0}
                          className="custom_accordio custom_all_event_accor"
                          eventKey={item.index}>
                          <Card>
                            <Card.Header className="accor_header">
                              <CustomToggle
                                eventKey={item.index}
                                // onClick={handleIcon()}
                                className="open_close_icon"
                                icon
                                handleIconm={handleIconss}>
                                <div
                                  // onClick={handleIcon()}
                                  onClick={() => toggleAccordionn(item._id)}
                                  className="accor_collapse">
                                  {isOpenn !== item._id ? (
                                    <img
                                      src={Plus}
                                      alt="icons"
                                      className="img-fluid plus_minus_icon"
                                    />
                                  ) : (
                                    <img
                                      src={Minus}
                                      alt="icons"
                                      className="img-fluid plus_minus_icon"
                                    />
                                  )}
                                </div>
                              </CustomToggle>

                              <div className="d-flex align-items-center accor_heading_title">
                                <span>{item._id}</span>
                              </div>
                              <span>{item.count}</span>
                            </Card.Header>

                            <Accordion.Collapse eventKey={item.index}>
                              <Card.Body>
                                <div className="accor_body">
                                  <div className="d-flex align-items-center mb-2 check_box">
                                    <input
                                      type="checkbox"
                                      onChange={(e) => {
                                        handleSelectAll(e, item, index);
                                      }}
                                      checked={
                                        isCheckAll.find(
                                          (val) => val == index
                                        ) != undefined
                                          ? true
                                          : false
                                      }
                                      id={index}
                                    />
                                    <span className="ps-2">
                                      All {item.count}
                                    </span>
                                  </div>
                                  <SingelEvents
                                    gameType={item._id}
                                    handleselect={handleselect}
                                  />
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    </div>
                  );
                }
                if (selectedSport == "All") {
                  return (
                    <div key={item._id} className="row mx-auto">
                      <div className="col-xxl-5 col-xl-6 col-lg-5 col-md-7 col-sm-8 col-12">
                        <Accordion
                          // defaultActiveKey={0}
                          defaultActiveKey={SelectDisplay ? 1 : 0}
                          className="custom_accordio custom_all_event_accor"
                          eventKey={item.index}>
                          <Card>
                            <Card.Header className="accor_header">
                              <CustomToggle
                                eventKey={item.index}
                                // onClick={handleIcon()}
                                className="open_close_icon"
                                icon
                                handleIconm={handleIconss}>
                                <div
                                  // onClick={handleIcon()}
                                  onClick={() => toggleAccordionn(item._id)}
                                  className="accor_collapse">
                                  {isOpenn !== item._id ? (
                                    <img
                                      src={Plus}
                                      alt="icons"
                                      className="img-fluid plus_minus_icon"
                                    />
                                  ) : (
                                    <img
                                      src={Minus}
                                      alt="icons"
                                      className="img-fluid plus_minus_icon"
                                    />
                                  )}
                                </div>
                              </CustomToggle>

                              <div className="d-flex align-items-center accor_heading_title">
                                <span>{item._id}</span>
                              </div>
                              <span>{item.count}</span>
                            </Card.Header>

                            <Accordion.Collapse eventKey={item.index}>
                              <Card.Body>
                                <div className="accor_body">
                                  <SingelEvents
                                    gameType={item._id}
                                    handleselect={handleselect}
                                  />
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    </div>
                  );
                }
              }
            })
            : eventMessage}
        </div>
      </DataFetchStatus>
    </div>
  );
}

export default AllEvents;
